import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock, LogIn, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PlayGate({ playsLeft }) {
  const { setShowAuth } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto text-center py-16 px-6" data-testid="play-gate">
      <div className="w-16 h-16 rounded-full bg-neon-pink/10 border-2 border-neon-pink flex items-center justify-center mx-auto mb-6">
        <Lock className="w-7 h-7 text-neon-pink" />
      </div>
      <h2 className="font-display font-black text-3xl uppercase tracking-tight mb-2">Out of Free Plays</h2>
      <p className="text-zinc-400 mb-8">
        You've used your free plays. Create a free account to keep playing unlimited games and save your high scores to the leaderboard!
      </p>
      <div className="flex flex-col gap-3">
        <Button onClick={() => setShowAuth(true)} data-testid="gate-login-btn"
          className="bg-neon-cyan text-black rounded-none font-bold uppercase tracking-widest h-12">
          <LogIn className="w-4 h-4 mr-2" /> Log In / Sign Up — It's Free
        </Button>
        <Button onClick={() => navigate("/subscribe")} variant="outline"
          className="border-neon-pink text-neon-pink bg-transparent rounded-none font-bold uppercase tracking-widest h-12 hover:bg-neon-pink hover:text-white">
          <Crown className="w-4 h-4 mr-2" /> Go Premium for Ad-Free
        </Button>
      </div>
    </div>
  );
}
